var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgba(21,27,38,.75)",
    viewBox: "0 0 24 24",
    title: "shoe",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MultiColorIcon-path--fadedBlack",
    d: "M1,10l14,14h9v-2h-7l-8.9-8.9c1.4-1.1,2.2-2.9,1.8-4.7C9.6,6.5,8.2,5,6.5,4.5L1,10z M14,9c0-0.6,0.4-1,1-1h3v2 h-3C14.4,10,14,9.6,14,9z M14,13c0-0.6,0.4-1,1-1h3v2h-3C14.4,14,14,13.6,14,13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "MultiColorIcon-path--white",
    d: "M11,0L6.5,4.5c1.7,0.5,3.1,2,3.4,3.8c0.3,1.9-0.4,3.6-1.8,4.7L17,22h1h6c0-3.3-2.7-6-6-6v-2h-3 c-0.6,0-1-0.4-1-1s0.4-1,1-1h3v-2h-3c-0.6,0-1-0.4-1-1s0.4-1,1-1h3V7L11,0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoe);
export default __webpack_public_path__ + "static/media/shoe.c3b0b212.svg";
export { ForwardRef as ReactComponent };